import React from "react";
import {
  CalcularDescuento,
  CalcularIva,
  CalcularSubTotal,
  CalcularSubTotalFactura,
  CalcularTotalFactura,
  CalcularAdministracion,
  CalcularImprevistos,
  CalcularIvaUtilidad,
  CalcularUtilidad,
  CalcularParcial,
  CalcularUnitario,
  CalcularSubTotalDescuento,
  CalcularDescuentoIva,
  calcSubtotalQuote,
  formatMoney,
} from "../Utili";

const IvaPleno = ({ doc }) => {
  const { articulos = [], descuento = 0, iva = 0,tipo } = doc;
  const subtotal = calcSubtotalQuote(articulos,tipo);
  const totalIva = CalcularIva(subtotal, iva);
  const subTotalFactura = CalcularSubTotalFactura(subtotal, totalIva);

  const totalDescuento = CalcularDescuento(subtotal, descuento);
  const subTotalDescuento = CalcularSubTotalDescuento(subtotal, totalDescuento);
  const ivaDescuento = CalcularDescuentoIva(subTotalDescuento, iva);

  const totalFactura = CalcularTotalFactura(subTotalDescuento, -ivaDescuento);

  return (
    <>
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th
          align="left"
          style={{ background: "silver", padding: 1 }}
          width={150}
        >
          SUBTOTAL
        </th>
        <td align="right" width={150}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(subtotal)}</span>
        </td>
      </tr>

      <tr className={descuento > 0 ? "no-print" : ""}>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th
          align="left"
          className={descuento > 0 ? "tachado" : ""}
          style={{ background: "silver", padding: 1 }}
        >
          IVA {iva} %
        </th>
        <td
          align="right"
          className={descuento > 0 ? "tachado" : ""}
          style={{ padding: 1 }}
        >
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalIva)}</span>
        </td>
      </tr>
      {/*<tr className={descuento > 0 ? "no-print" : ""}>
        <td colSpan={3}></td>
        <th
          align="left"
          className={descuento > 0 ? "tachado" : ""}
          style={{ background: "silver", padding: 1 }}
        >
          Total
        </th>
        <td
          align="right"
          className={descuento > 0 ? "tachado" : ""}
          style={{ padding: 1 }}
        >
          <Statistic
            title=""
            precision={0}
            prefix="$"
            value={subTotalFactura}
          />
        </td>
      </tr>*/}
      {descuento > 0 ? (
        <tr>
          <td colSpan={tipo=='M' ? 4:3}></td>
          <th align="left" style={{ background: "silver", padding: 1 }}>
            DESCUENTO {descuento} %
          </th>
          <td align="right">
            <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalDescuento)}</span>
          </td>
        </tr>
      ) : null}
      {descuento > 0 ? (
        <React.Fragment>
          <tr>
            <td colSpan={tipo=='M' ? 4:3}></td>
            <th align="left" style={{ background: "silver", padding: 1 }}>
              SUBTOTAL
            </th>
            <td align="right" style={{ padding: 1 }}>
              <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(subTotalDescuento)}</span>
            </td>
          </tr>
          <tr>
            <td colSpan={tipo=='M' ? 4:3}></td>
            <th align="left" style={{ background: "silver", padding: 1 }}>
              IVA
            </th>
            <td align="right" style={{ padding: 1 }}>
              <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(ivaDescuento)}</span>
            </td>
          </tr>
        </React.Fragment>
      ) : null}
      <tr>
        <td colSpan={tipo=='M' ? 4:3}></td>
        <th align="left" style={{ background: "silver", padding: 1 }}>
          TOTAL
        </th>
        <td align="right" style={{ padding: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 500 }}>${formatMoney(totalFactura)}</span>
        </td>
      </tr>
    </>
  );
};

export default IvaPleno;
